/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Heading, SkeletonBodyText, SkeletonThumbnail } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Carousel } from 'src/components/views/common/carousel';

class BoostInsightHub extends Component<WithI18nProps> {
  render() {
    const { i18n, boostInsightHubs, dashboardComponentsLoading } = this.props;

    let elements = [];
    if (dashboardComponentsLoading) {
      elements = this.renderSkeleton();
    } else {
      elements = this.renderListPost(i18n, boostInsightHubs);
    }

    return (
      <div className="BC-BoostInsightsHub__DashboardV3">
        <Card sectioned>
          <Heading>{i18n.translate('AdminHTML.DashboardV3.BoostInsightsHub.title')}</Heading>
          <div>
            <Carousel items={elements} autoDisplay={true} timeInterval={10000} />
          </div>
        </Card>
      </div>
    );
  }

  renderSkeleton = () => {
    const elements = [];
    for (let index = 0; index <= 2; index++) {
      elements.push(
        <div
          style={{
            height: '100%',
            padding: '25px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}>
          <SkeletonThumbnail size="large" />
          <div>
            <SkeletonBodyText lines={5} />
          </div>
        </div>
      );
    }

    return elements;
  };

  renderListPost = (i18n: any, posts: Array = []) => {
    const slicedPost = posts.length > 6 ? posts.slice(0, 6) : posts;
    const elements = slicedPost.map((post, idx) => {
      const { img, title, link } = post;
      return (
        <div className={`card`} onClick={() => window.open(link, '_blank')} key={idx}>
          <div className="img">
            <img src={img} alt={title} />
          </div>
          <p className="title">{title}</p>
        </div>
      );
    });

    return elements;
  };
}

const mapStateToProps = (state, props) => {
  return {
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    features: _.get(state.dashboardV3, 'features', {}),
    gettingFeatures: _.get(state.dashboardV3, 'gettingFeatures', {}),
    boostInsightHubs: _.get(state.dashboard, 'dashboardComponents.boostInsightHubs.data', []),
    dashboardComponentsLoading: _.get(state.dashboard, 'dashboardComponentsLoading', false)
  };
};

export default connect(mapStateToProps, null)(withI18n()(BoostInsightHub));
